'use strict';

import {
    INTEGRACION_PANTALLAS_MAXWELL_CARGA_INICIAL,
    INTEGRACION_PANTALLAS_MAXWELL_MOSTRAR_MODAL
} from '../../Screens/IntegracionPantallas/actions/Actions';

const initialState = {
    data: {
        mostrarModal: false,
        modalMensaje: "",
        urlSitio: ""
    }
};


function integracionPantallas(state = initialState, action) {
    let result;

    switch (action.type) {
        case INTEGRACION_PANTALLAS_MAXWELL_CARGA_INICIAL: {
            result = {
                ...state,
                data: {
                    ...state.data,
                    urlSitio: action.urlSitio,
                    token: action.token
                }
            };
        }
        break;

        case INTEGRACION_PANTALLAS_MAXWELL_MOSTRAR_MODAL: {
            result = {
                ...state,
                data: {
                    ...state.data,
                    mostrarModal: action.mostrarModal,
                    modalMensaje: action.mensaje
                }
            };
        }
        break;

        default: {
            result = {
                ...state
            };
        }
        break;
    }

    return result;
}

export default integracionPantallas;
